export default __webpack_public_path__ + "static/media/CNo.59-3.e1b5bd73.jpg";